import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './VendorDetails.css';
import api from '../../api/axios.js';
import { FiEdit } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const InfluencerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [blockActionLoading, setBlockActionLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [editUserForm, setEditUserForm] = useState({
    name: "",
    email: "",
    mobile_number: "",
  });
  const [influencerData, setInfluencerData] = useState({
  name: '',
  email: '',
  phone: '',
  gender: '',
  coins: 0,
  dateOfJoining: '',
  status: '',
  roles: []
});

  useEffect(() => {
    fetchInfluencerDetails();
  }, [id]);

  const fetchInfluencerDetails = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/listing/vendor-details/${id}`);
      const user = res?.data?.data?.user;

      setInfluencerData({
  name: user?.name || '',
  email: user?.email || '',
  phone: user?.mobile_number || '',
  gender: user?.gender || '',
  coins: user?.coins || 0,
  dateOfJoining: user?.date_of_joining || '',
  status: user?.status || '',
  roles: user?.roles || [],
  influencerProfileCompletion: user?.influencerProfileCompletion || 0
});
    } catch (err) {
      console.error('Error fetching influencer details', err);
      toast.error('Failed to load influencer details');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/user-management');
  };

  const handleEdit = () => {
    setFormErrors({});
    setEditUserForm({
      name: influencerData.name || "",
      email: influencerData.email || "",
      mobile_number: influencerData.phone || "",
    });
    setShowEditModal(true);
  };

  const isInfluencerBlocked = ["inactive", "blocked"].includes(
    (influencerData?.status || "").toLowerCase()
  );

  const handleToggleBlockStatus = async () => {
    try {
      setBlockActionLoading(true);
      if (isInfluencerBlocked) {
        await api.put(`/admin/reactivate/user/${id}`);
        toast.success("Influencer unblocked successfully");
      } else {
        await api.put(`/admin/soft-delete/user/${id}`, {
          reason: "inactive",
        });
        toast.success("Influencer blocked successfully");
      }
      await fetchInfluencerDetails();
    } catch (err) {
      console.error("Block/unblock failed", err);
      toast.error(err?.response?.data?.message || "Block/unblock failed");
    } finally {
      setBlockActionLoading(false);
    }
  };

  const handleSave = async () => {
    const errors = {};
    if (!editUserForm.name?.trim()) errors.name = "Name is required";
    if (!editUserForm.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(editUserForm.email)) {
      errors.email = "Invalid email format";
    }
    if (!editUserForm.mobile_number?.trim()) {
      errors.mobile_number = "Mobile number is required";
    } else if (!/^\d{10}$/.test(editUserForm.mobile_number)) {
      errors.mobile_number = "Mobile number must be 10 digits";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      await api.put(`/admin/update/user/${id}`, {
        name: editUserForm.name,
        email: editUserForm.email,
        mobile_number: editUserForm.mobile_number,
      });
      toast.success("Influencer updated successfully");
      setFormErrors({});
      setShowEditModal(false);
      fetchInfluencerDetails();
    } catch (err) {
      console.error('Error updating influencer', err);
      if (err?.response?.status === 409) {
        setFormErrors({ email: "Email already exists" });
        return;
      }
      toast.error(err?.response?.data?.message || "Failed to update influencer");
    }
  };

  if (loading) {
    return (
      <div className="vendor-details">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading influencer details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="vendor-details">
      <div className="details-header">
        <button className="back-btn" onClick={handleBack}>← Back</button>
        <div className="header-actions">
          <h1>👤 Influencer Details</h1>
          <button className="edit-btn" onClick={handleEdit}><FiEdit /> Edit</button>
          <button
            className="edit-btn"
            onClick={handleToggleBlockStatus}
            disabled={blockActionLoading}
          >
            {blockActionLoading
              ? "Please wait..."
              : isInfluencerBlocked
              ? "Unblock Influencer"
              : "Block Influencer"}
          </button>
        </div>
      </div>

      <div className="vendor-info">
        <div className="info-section">
          <div className="info-grid2">
            <div className="info-item2 name-item">
              <span className="label">Name</span>
              <span className="value">
                {influencerData.name
                  ? influencerData.name
                      .toLowerCase()
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ')
                  : 'N/A'}
              </span>
            </div>

            <div className="info-item2 email-item">
              <span className="label">Email</span>
              <span className="value">
                {influencerData.email?.trim() || 'N/A'}
              </span>
            </div>

            <div className="info-item2 phone-item">
              <span className="label">Phone</span>
              <span className="value">
                {influencerData.phone?.trim() || 'N/A'}
              </span>
            </div>

            <div className="info-item2 gender-item">
              <span className="label">Gender</span>
              <span className="value">
                {influencerData.gender?.trim() || 'N/A'}
              </span>
            </div>

            <div className="info-item2 roles-item">
  <span className="label">Roles</span>

  <div className="roles-wrapper">
    {influencerData?.roles?.length ? (
      influencerData.roles.map((role, index) => (
        <span key={index} className="role-badge">
          {role.userType.charAt(0).toUpperCase() +
            role.userType.slice(1)}
        </span>
      ))
    ) : (
      <span className="value">N/A</span>
    )}
  </div>
</div>

            <div className="info-item2 doj-item">
              <span className="label">Date of Joining</span>
              <span className="value">
                {influencerData?.dateOfJoining
                  ? new Date(influencerData.dateOfJoining).toLocaleDateString('en-IN')
                  : 'N/A'}
              </span>
            </div>

            <div className="info-item2 status-item">
              <span className="label">Status</span>
              <span className={`value status-badge ${influencerData.status}`}>
                {influencerData.status ? influencerData.status.charAt(0).toUpperCase() + influencerData.status.slice(1) : 'N/A'}
              </span>
            </div>
            <div className="profile-completion">
  <div className="label">
    Profile Completion: {influencerData.influencerProfileCompletion}%
  </div>

  <div className="progress-bar">
    <div
      className="progress-fill"
      style={{
        width: `${influencerData.influencerProfileCompletion}%`
      }}
    />
  </div>
</div>
          </div>
        </div>
      </div>

      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Influencer</h2>
            <input
              placeholder="Name"
              value={editUserForm.name || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, name: e.target.value })}
            />
            {formErrors.name && <span className="form-error">{formErrors.name}</span>}

            <input
              placeholder="Email"
              value={editUserForm.email || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, email: e.target.value })}
            />
            {formErrors.email && <span className="form-error">{formErrors.email}</span>}

            <input
              placeholder="Mobile"
              value={editUserForm.mobile_number || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, mobile_number: e.target.value })}
            />
            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}

            <div className="form-actions">
              <button type="button" onClick={() => setShowEditModal(false)}>
                Cancel
              </button>
              <button type="button" onClick={handleSave}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default InfluencerDetails;
